import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import { Delete, Visibility, Download } from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../reducers/userProfileSlice";
import "../../assets/scss/styles/TargetSales.css";

function YearList(props) {
  const [mboList, setMboList] = useState([]);

  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const countPerPage = 10;
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const userProfile = useSelector((state) => state?.userProfile?.userProfile);
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const isRsm = utils.hasPermission(
    primaryMenuRes,
    "Sales Target",
    "sales_target.Regional_Sales_Manager_permissions"
  );

  const isSrRsm = utils.hasPermission(
    primaryMenuRes,
    "Sales Target",
    "sales_target.Sr_Regional_Sales_Manager_permissions"
  );
  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  useEffect(() => {
    getMboList();
  }, [page, userProfile?.id]);

  const getMboList = () => {
    var bodyFormData = new FormData();

    bodyFormData.append("page", page);
    bodyFormData.append("per_page", countPerPage);

    utils
      .callAPI(
        "get",
        `/sales/gettargetdetails?year=${props.rowData?.year}`,
        bodyFormData
      )
      .then((res) => {
        if (typeof res !== "undefined") {
          setMboList(res);
        } else {
          setMboList([]);
        }
      })
      .catch((err) => {
        setMboList([]);
      });
  };

  const handleView = useCallback((row) => async () => {
    console.log("Here is the props", row);
    const propdata = {
      mode: "MBOView",
      userData: row,
      rowData: props.rowData,
    };
    // props.setUserData(row);
    props.onChange(propdata);
  });

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const handleDownload = () => {
    const year = props?.rowData?.year; // Get the selected year
    const userId = userProfile?.id; // Assuming you want to download for the logged-in user

    const downloadUrl =
      process.env.REACT_APP_API_URL +
      `/sales/downloadexlList?year=${year}&id=${userId}`;

    // Open the URL in a new tab to trigger the download
    window.open(downloadUrl, "_blank");
  };

  return (
    <div className="section-body">
      <RB.Card className="card shadow ">
        <RB.Card.Header>
          <h4></h4>
          <div className="card-header-action">
            <div className="card-header-action">
              <RB.Button
                className="btn btn-primary me-2"
                onClick={handleBackClick}
              >
                Back
              </RB.Button>
              {(isRsm || isSrRsm) && (
                <RB.Button
                  className="btn btn-outline-dark ms-2"
                  onClick={handleDownload}
                >
                  Download Excel
                </RB.Button>
              )}
            </div>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <div className={"table-responsive p-0 border"}>
            <RB.Table
              bordered
              hover
              striped
              className="border mb-0 table-sm table-invoice-products"
            >
              <thead>
                <tr>
                  <th className="text-center" rowSpan={2}>
                    Sr. No.
                  </th>
                  <th className="text-center" rowSpan={2}>
                    Empl ID
                  </th>
                  <th className="text-center" rowSpan={2}>
                    Name
                  </th>
                  <th className="text-center" rowSpan={2}>
                    Designation
                  </th>
                  <th className="text-center" rowSpan={2}>
                    Location
                  </th>
                  <th className="text-center" rowSpan={2}>
                    Reporting Manager
                  </th>
                  <th className="text-center" rowSpan={2}>
                    Joining Date
                  </th>
                  <th colSpan={6} className={"text-center"}>
                    Quarter-1
                  </th>
                  <th colSpan={6} className={"text-center"}>
                    Quarter-2
                  </th>
                  <th colSpan={6} className={"text-center"}>
                    Quarter-3
                  </th>
                  <th colSpan={6} className={"text-center"}>
                    Quarter-4
                  </th>

                  {/* Total Target */}
                  <th className="text-center" rowSpan={2}>
                    Total <br /> Target
                  </th>

                  {/* Total Achi. */}
                  <th className="text-center" rowSpan={2}>
                    Total <br /> Achi.
                  </th>

                  {/* Total Shortfall */}
                  <th className="text-center" rowSpan={2}>
                    Shortfall
                  </th>

                  {/* View Button */}
                  <th className="text-center" rowSpan={2}>
                    View
                  </th>
                </tr>
                <tr>
                  <th className={"text-center"}>Target</th>
                  <th className={"text-center"}>Jan</th>
                  <th className={"text-center"}>Feb</th>
                  <th className={"text-center"}>Mar</th>
                  <th className={"text-center"}>Achi.</th>
                  <th className={"text-center"}>Shortfall</th>

                  <th className={"text-center"}>Target</th>
                  <th className={"text-center"}>Apr</th>
                  <th className={"text-center"}>May</th>
                  <th className={"text-center"}>Jun</th>
                  <th className={"text-center"}>Achi.</th>
                  <th className={"text-center"}>Shortfall</th>

                  <th className={"text-center"}>Target</th>
                  <th className={"text-center"}>Jul</th>
                  <th className={"text-center"}>Aug</th>
                  <th className={"text-center"}>Sep</th>
                  <th className={"text-center"}>Achi.</th>
                  <th className={"text-center"}>Shortfall</th>

                  <th className={"text-center"}>Target</th>
                  <th className={"text-center"}>Oct</th>
                  <th className={"text-center"}>Nov</th>
                  <th className={"text-center"}>Dec</th>
                  <th className={"text-center"}>Achi.</th>
                  <th className={"text-center"}>Shortfall</th>
                </tr>
              </thead>

              <tbody>
                {mboList.map((row, index) => (
                  <tr key={index} className="text-center">
                    <td>{index + 1}</td>
                    <td>{row.employeeId}</td>
                    <td>{row.firstName + " " + row.lastName}</td>
                    <td>{row.roleName}</td>
                    <td>{row.location}</td>
                    <td>{row.reporting_manager_nm}</td>
                    <td>{moment(row.join_date).format("D/M/YYYY")}</td>
                    {console.log("Hers iss", row.quarter[0].target)}
                    <td className={"text-end"}>{row.quarter[0].target}</td>
                    <td className={"text-end"}>
                      {row.quarter[0].months[0].total}
                    </td>
                    <td className={"text-end"}>
                      {row.quarter[0].months[1].total}
                    </td>
                    <td className={"text-end"}>
                      {row.quarter[0].months[2].total}
                    </td>
                    <td className={"text-end"}>{row.quarter[0].total}</td>
                    <td className={"text-end"} style={{ color: "red" }}>
                      {row.quarter[0].shortfall}
                    </td>

                    <td className={"text-end"}>{row.quarter[1].target}</td>
                    <td className={"text-end"}>
                      {row.quarter[1].months[0].total}
                    </td>
                    <td className={"text-end"}>
                      {row.quarter[1].months[1].total}
                    </td>
                    <td className={"text-end"}>
                      {row.quarter[1].months[2].total}
                    </td>
                    <td className={"text-end"}>{row.quarter[1].total}</td>
                    <td className={"text-end"} style={{ color: "red" }}>
                      {row.quarter[1].shortfall}
                    </td>

                    {/* Quarter 3 Details */}

                    <td className={"text-end"}>{row.quarter[2].target}</td>
                    <td className={"text-end"}>
                      {row.quarter[2].months[0].total}
                    </td>
                    <td className={"text-end"}>
                      {row.quarter[2].months[1].total}
                    </td>
                    <td className={"text-end"}>
                      {row.quarter[2].months[2].total}
                    </td>
                    <td className={"text-end"}>{row.quarter[2].total}</td>
                    <td className={"text-end"} style={{ color: "red" }}>
                      {row.quarter[2].shortfall}
                    </td>

                    <td className={"text-end"}>{row.quarter[3].target}</td>
                    <td className={"text-end"}>
                      {row.quarter[3].months[0].total}
                    </td>
                    <td className={"text-end"}>
                      {row.quarter[3].months[1].total}
                    </td>
                    <td className={"text-end"}>
                      {row.quarter[3].months[2].total}
                    </td>
                    <td className={"text-end"}>{row.quarter[3].total}</td>
                    <td className={"text-end"} style={{ color: "red" }}>
                      {row.quarter[3].shortfall}
                    </td>

                    {/* Total Target (Sum of all quarters) */}
                    <td>
                      {parseFloat(row.quarter[0].target || 0) +
                        parseFloat(row.quarter[1].target || 0) +
                        parseFloat(row.quarter[2].target || 0) +
                        parseFloat(row.quarter[3].target || 0)}
                    </td>

                    {/* Total Achi. */}
                    <td>{row.total_archi}</td>

                    {/* Total Shortfall */}
                    <td>
                      <span style={{ color: "red" }}>
                        {row.total_shortfall}
                      </span>
                    </td>

                    {/* View Button */}
                    <td>
                      <RB.Button
                        className="btn-circle"
                        variant="outline-primary"
                        size="sm"
                        onClick={handleView(row)}
                      >
                        <Visibility />
                      </RB.Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </RB.Table>
          </div>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default YearList;
